export const BASE64_REGEX = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

export const base = (type?: string): string => `data:image/${type || "png"};base64,`;

export const convertToBase64 = (file: File) => {
  return new Promise<string | ArrayBuffer | null | ProgressEvent<FileReader>>((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};
